module.exports = __webpack_public_path__ + "img/charade-false.89a26642.svg";